import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const JoinConversationModal = ({ open, onClose, onConfirm, defaultAgentName = '' }) => {
  const [agentName, setAgentName] = useState('');
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (open) {
      setAgentName(defaultAgentName);
    }
  }, [open, defaultAgentName]);

  const handleConfirm = () => {
    onConfirm(agentName.trim());
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          padding: isMobile ? '20px' : '30px',
          width: isMobile ? '80%' : '90%',
          maxWidth: 400,
        }}
      >
        <h2 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: 600 }}>
          {t('live_inbox_join_modal_title') || 'Join Conversation'}
        </h2>
        <p style={{ margin: '0 0 16px 0', fontSize: '14px', color: '#6b7280' }}>
          {t('live_inbox_join_modal_desc') || 'Enter your display name for this conversation.'}
        </p>
        <TextField
          fullWidth
          label={t('live_inbox_join_modal_name_label') || 'Display Name'}
          value={agentName}
          onChange={(e) => setAgentName(e.target.value)}
          variant="outlined"
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleConfirm();
            }
          }}
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root.Mui-focused': {
              '& fieldset': {
                border: '1px solid #515151',
              },
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
              '&.Mui-focused': {
                color: '#5616ea',
              },
            },
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: '#5616ea',
              borderColor: '#5616ea',
              '&:hover': {
                borderColor: '#5e0fb3',
                backgroundColor: '#f3eaff',
              },
            }}
          >
            {t('cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#5616ea',
              '&:hover': {
                backgroundColor: '#4a14d6',
              },
            }}
          >
            {t('live_inbox_join') || 'Join'}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default JoinConversationModal;
